import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavItemLink } from '../components/item/NavItem';
import styles from './nav_features_button.module.scss';

export function NavFeaturesButton() {
  return (
    <NavItemLink
      className={styles.container}
      href="/fonctionnalites"
      source="header"
    >
      <FormattedMessage id="navigation/customers/NavFeaturesButton.tsx/1" />
    </NavItemLink>
  );
}
